import { Shield, Sparkles } from "lucide-react";
import Reveal from "./Reveal";

export default function JuniorGuardCard() {
  return (
    <section
      data-testid="junior-guard-card-section"
      id="junior-guard"
      className="border-t border-white/10 py-20 bg-[#0A0A0A]"
    >
      <div className="container-fld">
        <div className="overline mb-4 text-center">// Mentorship Team</div>
        <h3 className="font-tactical text-3xl md:text-4xl font-bold uppercase text-white tracking-tight text-center mb-12">
          Meet Our <span className="text-[#7CFF00]">Junior Guard</span>
        </h3>

        <div className="max-w-5xl mx-auto">
          <Reveal>
            <div
              data-testid="junior-guard-card"
              className="relative grid md:grid-cols-12 gap-0 bg-gradient-to-br from-[#0F0F0F] to-[#0A0A0A] border border-[#7CFF00]/30 overflow-hidden shadow-[0_0_48px_rgba(124,255,0,0.18)] hover:shadow-[0_0_64px_rgba(124,255,0,0.32)] transition-shadow duration-500"
            >
              {/* corner ticks */}
              <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-[#7CFF00] pointer-events-none" />
              <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-[#7CFF00] pointer-events-none" />
              <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-[#7CFF00] pointer-events-none" />
              <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-[#7CFF00] pointer-events-none" />

              {/* Photo */}
              <div className="md:col-span-5 relative bg-black">
                <div className="aspect-[4/5] w-full overflow-hidden">
                  <img
                    src="/junior-guard-dj.jpg"
                    alt="DJ — Frontline Defense Junior Guard"
                    data-testid="junior-guard-photo"
                    className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/70 via-transparent to-transparent pointer-events-none" />
                <div className="absolute bottom-3 left-3 right-3 md:hidden">
                  <div className="font-tactical text-white text-2xl uppercase tracking-tight">
                    Junior Guard <span className="text-[#7CFF00]">(DJ)</span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="md:col-span-7 p-6 md:p-10 flex flex-col justify-center">
                <span
                  data-testid="youth-peer-support-badge"
                  className="inline-flex items-center gap-1.5 self-start px-3 py-1 mb-5 bg-[#7CFF00] text-black text-[10px] uppercase tracking-[0.22em] font-tactical font-bold shadow-[0_0_18px_rgba(124,255,0,0.4)]"
                >
                  <Sparkles className="w-3 h-3" />
                  Youth Peer Support
                </span>

                <h4 className="hidden md:block font-tactical text-3xl md:text-4xl font-bold uppercase text-white tracking-tight leading-none">
                  Junior Guard <span className="text-[#7CFF00]">(DJ)</span>
                </h4>

                <div className="mt-5 space-y-4 text-zinc-300 leading-relaxed text-sm md:text-base">
                  <p>
                    DJ is Frontline Defense's Junior Guard and serves as a positive
                    peer role model for younger students during youth preparedness
                    sessions. Passionate about safety, discipline, and
                    confidence-building, DJ helps create a welcoming
                    beginner-friendly environment for youth participants learning
                    firearm safety fundamentals and range etiquette alongside their
                    parent or guardian.
                  </p>
                  <p>
                    As the founder's son, DJ helps younger students feel
                    comfortable, welcomed, and encouraged during beginner youth
                    sessions.
                  </p>
                </div>

                <div className="mt-6 pt-5 border-t border-white/10 flex items-start gap-2">
                  <Shield className="w-3.5 h-3.5 text-[#7CFF00] mt-0.5 flex-shrink-0" />
                  <p
                    data-testid="junior-guard-disclaimer"
                    className="text-[11px] md:text-xs text-zinc-500 font-mono-tactical leading-relaxed"
                  >
                    Junior Guard support is mentorship-based and does not represent
                    certified instructor credentials.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
